import { useQuery } from '@tanstack/react-query';

import { normalizeToStartOfDayUTC } from '@/utils/date-formatters';

import { getWorkingDays } from '../api/time-offs.api';
import { getWorkingDaysQueryKey } from '../constants/time-offs-query-keys';

/**
 * Fetches working/non-working days for the selected create-mode date range.
 * Disabled until both ends are picked. Dates are normalized to start-of-day UTC
 * so the same calendar range always resolves to the same query/key.
 */
export const useWorkingDays = (start: Date | null | undefined, end: Date | null | undefined) => {
  const startIso = start ? normalizeToStartOfDayUTC(start).toISOString() : undefined;
  const endIso = end ? normalizeToStartOfDayUTC(end).toISOString() : undefined;

  return useQuery({
    queryKey: getWorkingDaysQueryKey(startIso ?? '', endIso ?? ''),
    queryFn: () => getWorkingDays({ startDate: startIso as string, endDate: endIso as string }),
    enabled: !!startIso && !!endIso,
    // Working days for a fixed range are immutable; org-settings changes bust this
    // via WORKING_DAYS_QUERY_KEY (see invalidateOrganizationQueries).
    staleTime: Infinity,
  });
};
